<template>
  <div id="app">
    <keep-alive :include="cachedViews">
      <router-view></router-view>
    </keep-alive>
    <van-tabbar v-if="$route.meta.showTabbar" route v-model="tabbarActive" safe-area-inset-bottom active-color="#ee0a24"
      inactive-color="#aaa">
      <van-tabbar-item to="/home" name="home" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item to="/charts" name="search" icon="chart-trending-o">排行榜</van-tabbar-item>
      <van-tabbar-item to="/recommend" name="friends" icon="hot-o">推荐</van-tabbar-item>
      <van-tabbar-item to="/follow" name="setting" icon="friends-o">关注</van-tabbar-item>
      <van-tabbar-item to="/mine" name="setting" icon="user-o">我</van-tabbar-item>
    </van-tabbar>

  </div>
</template>


<script>

export default {
  name: 'App',
  data() {
    return {
      tabbarActive: 'home',
    }
  },
  computed: {
    cachedViews() {
      // 需要缓存的页面
      return this.$route.meta.keepAlive ? [this.$route.name] : []
    }
  },
  watch: {
    '$route'(to, from) {
      // 路由变化时滚动到顶部（非缓存页面）
      if (!to.meta.keepScroll) {
        window.scrollTo(0, 0)
      }
    }
  },
  mounted: function () {
    //console.log(this.$route.path)
  },
  methods: {
    clickFollow() {
      this.$router.push('/follow')
    },
  },
}
</script>


<style></style>
